import * as Yup from 'yup';
import { ILoginFormField, IQRCodeFormField, IForgotPasswordFormField, IResetPasswordFormField } from 'models/login';
import { Common } from 'utils/constants';
import { TFunction } from 'i18next';
export const LoginValidationSchema = (t: TFunction) => {
    return Yup.object().shape({
        Email: Yup.string()
            .matches(Common.RegularExpression.EmailRegularExpression, t('login.errors.email.email'))
            .required('required'),
        PassWord: Yup.string().required('required'),
    }) as Yup.SchemaOf<ILoginFormField>;
};

export const QRCodeValidationSchema = (t: TFunction) => {
    return Yup.object().shape({
        securityCode: Yup.string()
            .required('required')
            .min(6, t('login.errors.securityCode.max'))
            .max(6, t('login.errors.securityCode.max')),
    }) as Yup.SchemaOf<IQRCodeFormField>;
};

export const ForgotPassworValidationSchema = (t: TFunction) => {
    return Yup.object().shape({
        Email: Yup.string()
            .matches(Common.RegularExpression.EmailRegularExpression, t('login.errors.email.email'))
            .required('required'),
    }) as Yup.SchemaOf<IForgotPasswordFormField>;
};

export const ResetPassworValidationSchema = (t: TFunction, stage: number) => {
    const fields = {
        NewPassWord: Yup.string()
            .required('required')
            .matches(Common.RegularExpression.PasswordRegularExpression, t('login.errors.passwordFormat')),
        ConfirmPassWord: Yup.string()
            .required('required')
            .oneOf([Yup.ref('NewPassWord'), null], t('login.errors.confirmPasswordMatch')),
    };
    if (stage === Common.AuthStage.CHANGE_PASSWORD_WITH_VERIFICATION_CODE) {
        Object.assign(fields, {
            Code: Yup.string()
                .required('required')
                .matches(Common.RegularExpression.CodeRegularExpression, t('login.errors.verificationCodeFormat')),
        });
    }
    return Yup.object().shape(fields) as unknown as Yup.SchemaOf<IResetPasswordFormField>;
};
